import enUS from "date-fns/locale/en-US";
import nlLocale from "date-fns/locale/nl";

export const defaultLocale = "en";
export const supportedLocales = ["nl", "en"];

export const localeMap = {
  en: enUS,
  nl: nlLocale,
};

export const localeNames = {
  en: "English",
  nl: "Nederlands",
};
